import React from 'react';
import { Translate } from 'react-localize-redux';
import { NavLink } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PdfExportButton } from '../common/refButtons';
import { registrySearchActions, REGISTRY, checkPerm } from '../../store/ceeSearchStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import flagCz from "../../img/vlajka_cz.svg";
import flagSk from "../../img/vlajka_sk.svg";
import classnames from 'classnames';
import MainHeader from './mainHeader';

import './headersCommon.scss'

class CeeSearchHeader extends React.Component {

    subjectSubpath = 'subject';
    causeSubpath = 'cause';
    resultsSubpath = 'results';

    render() {
        return (<>
            <MainHeader label={this.getLabel(this.props.registry)} flag={this.getFlag(this.props.registry)} {...this.props} />

            {!this.props.isMobile && <div className={classnames('tabs tabs-subheader shadowed', { 'tinted': this.props.tinted })}>
                <ul style={{ border: "none" }}>
                    {checkPerm(this.props.registry, "SearchCEE", "SearchCRE", "AMLSearch", "SearchRPVE") &&
                        <li className={`tab-link ${this.isActiveLink(this.subjectSubpath) ? 'is-active' : ''}`}>
                            <NavLink to={{ pathname: `${this.props.match.url}/${this.subjectSubpath}`, state: this.props.location.state }}>
                                <Translate id='Search.Common.SubjectSearch' />
                            </NavLink>
                            <div className="search-progress-short" style={{ display: this.isActiveLink(this.subjectSubpath) ? "" : "none" }}></div>
                        </li>
                    }
                    {/*(this.props.registry === REGISTRY.cee || this.props.registry === REGISTRY.cre) &&
                        <li className={`tab-link ${this.endsWith(this.props.location.pathname, this.causeSubpath) ? 'is-active' : ''}`}>
                            <NavLink to={`${this.props.match.url}/${this.causeSubpath}`}><Translate id='Search.Common.CauseSearch' /></NavLink>
                            <div className="search-progress-short" style={{ display: this.endsWith(this.props.location.pathname, this.causeSubpath) ? "" : "none" }}></div>
                        </li>
                    */}
                    {checkPerm(this.props.registry, "CEEReport", "CREReport", "AMLSearch", "SearchRPVE") &&
                        <li className={`tab-link ${this.isActiveLink(this.resultsSubpath) ? 'is-active' : ''}`}>
                            <NavLink to={`${this.props.match.url}/${this.resultsSubpath}`}><Translate id='Search.Common.Requests' /></NavLink>
                            <div className="search-progress-short" style={{ display: this.isActiveLink(this.resultsSubpath) ? "" : "none" }}></div>
                        </li>
                    }
                </ul>
                {!this.props.isMobile && this.isActiveLink(this.resultsSubpath) && this.renderPdfExport()}
            </div>}
        </>)
    }

    getLabel = (registry) => {
        switch (registry) {
            case REGISTRY.cee: return 'Search.Cee.SectionName';
            case REGISTRY.cre: return 'Search.Cre.SectionName';
            case REGISTRY.aml: return 'Search.Aml.SectionName';
            case REGISTRY.rpve: return 'Search.Rpve.QueryResult';

            default: return '';
        }
    }

    getFlag = (registry) => {
        switch (registry) {
            case REGISTRY.cee: return flagCz;
            case REGISTRY.rpve:
            case REGISTRY.cre: return flagSk;
            case REGISTRY.aml:
            default: return undefined;
        }
    }

    isActiveLink = (item) => this.props.location.pathname.indexOf(item) >= 0;

    renderPdfExport = () => {
        if (this.props.location.pathname.substring(this.props.location.pathname.lastIndexOf('/') + 1) === 'results')
            return null;

        const m = this.props.location.pathname.match(/search\/\w+\/results/);
        if (m === null)
            return null;
        const reg = m[0].split('/')[1];

        const params = isNullOrUndefined(this.props[reg]) ? null : this.props[reg].resultsRequestParams;

        if (isNullOrUndefined(params))
            return null;

        return (
            <div className='search-pdf-export'>
                <div className='references print-hidden'>
                    <div className="ref-buttons" style={{ display: 'flex' }}>
                        <PdfExportButton onClick={() => this.props.exportPdf(reg)} />
                    </div>
                </div>
            </div>);
    }
}

export default withRouter(connect(
    state => state.registrySearch,
    dispatch => bindActionCreators({ ...registrySearchActions }, dispatch)
)(CeeSearchHeader));